import { render, staticRenderFns } from "./musicChart.vue?vue&type=template&id=371fe96c&scoped=true&"
import script from "./musicChart.vue?vue&type=script&lang=js&"
export * from "./musicChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371fe96c",
  null
  
)

export default component.exports